/**
 * The most entries a single export can hold. Only used to tell the user about
 * it up front - the API is what enforces it (ENTRIES_EXPORT_LIMIT there), so
 * keep the two in step.
 */
export const ENTRIES_EXPORT_LIMIT = 10_000;
